module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whiteWrapper full-w flex justify-center",
    staticStyle: {
      "padding": "50px"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e5c46b","hasScoped":false}!./src/app/components/noData/noData.html
// module id = 2983
// module chunks = 1